import React, { useState, useEffect, useCallback } from "react";
import "./ViewQuotationEnquiry.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Navbar, Nav, Container, Row, Col, Card, Dropdown, Table } from "react-bootstrap";
import Logo from "../src/Photos/eximtracfinallogo.png";
import Account from "../src/Photos/Account.png";
import * as XLSX from "xlsx";

import { hasAccess } from "../src/roleAccess.js";

function ViewQuotationEnquiry() {

    const scrollToTop = () => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    };

    const navigate = useNavigate();


    // const [showPopup, setShowPopup] = useState(false);

    // const handleSubmit = (event) => {
    //     event.preventDefault();
    //     setShowPopup(true); // Show popup when submitted
    // };

    // const handleClose = () => {
    //     setShowPopup(false); // Hide popup
    // };

    // const userId = localStorage.getItem('userId');

    // const token = localStorage.getItem('token');

    // States for file inputs
    // const [quotationFile, setQuotationFile] = useState(null);

    // const { userId, orderId } = useParams(); // Get UserID and OrderID from the URL
    // const [message, setMessage] = useState("");
    // const [messageType, setMessageType] = useState(""); // "success" or "danger"

    // // Handle file selection
    // const handleFileChange = (e) => {
    //     const files = e.target.files;
    //     setQuotationFile(files ? files[0] : null); // Ensure only one file is uploaded
    // };

    // Handle form submission
    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     if (!userId || !orderId) {
    //         setMessage("Invalid UserID or OrderID. Please check the URL.");
    //         setMessageType("danger");
    //         return;
    //     }

    //     // Validate file input
    //     if (!quotationFile) {
    //         setMessage("Please select a file to upload.");
    //         setMessageType("danger");
    //         return;
    //     }

    //     const formData = new FormData();
    //     formData.append("quotationFile", quotationFile); // Ensure correct field name
    //     formData.append("DocumentType", "Quotation"); // Fixed value for DocumentType

    //     try {
    //         const response = await fetch(`https://api-ft5g.onrender.com/enquiry-quotation-files/${orderId}/${userId}`, {
    //             method: "POST",
    //             body: formData,
    //         });

    //         if (response.ok) {
    //             const data = await response.json();
    //             console.log("Upload successful:", data);
    //             setMessage("File uploaded successfully!");
    //             setMessageType("success");
    //         } else {
    //             const error = await response.json();
    //             setMessage(error.message || "File upload failed.");
    //             setMessageType("danger");
    //         }
    //     } catch (err) {
    //         console.error("Error during upload:", err);
    //         setMessage("Network error. Please try again.");
    //         setMessageType("danger");
    //     }
    // };


    // const navigate = useNavigate();
    // const [orderDetails, setOrderDetails] = useState([]);

    // useEffect(() => {
    //     // Get OrderID from localStorage
    //     const selectedOrderId = localStorage.getItem("selectedOrderId");

    //     if (selectedOrderId) {
    //         // Fetch data and filter by OrderID
    //         fetch(`http://localhost:2000/Get-container-place-enquiry-user-and-admin/${userId}`)
    //             .then((res) => res.json())
    //             .then((docs) => {
    //                 if (docs && docs.data) {
    //                     const filteredOrder = docs.data.filter(
    //                         (item) => item.OrderID === selectedOrderId
    //                     );
    //                     setOrderDetails(filteredOrder);
    //                 }
    //             })
    //             .catch((error) => {
    //                 console.error("Error fetching data:", error);
    //             });
    //     }

    //     // (Optional) Clear the stored OrderID after use
    //     return () => {
    //         sessionStorage.removeItem("selectedOrderId");
    //     };
    // }, []);

    // const { orderId, userId } = useParams();

    // const [userDetails, setUserDetails] = useState([]);

    // useEffect(() => {
    //     // Adjust the API URL based on the backend route
    //     const url = orderId
    //         ? `https://api-ft5g.onrender.com/Get-container-place-enquiry-user-and-admin/${userId}/${orderId}`
    //         : `https://api-ft5g.onrender.com/Get-container-place-enquiry-user-and-admin/${userId}`;

    //     fetch(url)
    //         .then((res) => {
    //             if (!res.ok) {
    //                 throw new Error(`HTTP error! Status: ${res.status}`);
    //             }
    //             return res.json();
    //         })
    //         .then((data) => setUserDetails(data.data))
    //         .catch((err) => console.error("Error fetching data:", err));
    // }, [orderId, userId]);


    // const [files, setFiles] = useState([]);
    // const [error, setError] = useState("");

    // Fetch files from the backend
    // useEffect(() => {
    //     fetch(`https://api-ft5g.onrender.com/enquiry-quotation-files-admin/${userId}/${orderId}`)
    //         .then((res) => res.json())
    //         .then((data) => {
    //             if (data.files) {
    //                 setFiles(data.files);
    //             } else {
    //                 setError(data.message || "Failed to fetch files");
    //             }
    //         })
    //         .catch((err) => {
    //             console.error("Error fetching files:", err);
    //             setError("Failed to fetch files");
    //         });
    // }, [userId, orderId]);

    // Handle file download
    // const handleDownload = (fileName) => {
    //     window.open(`https://api-ft5g.onrender.com/download-file/${fileName}`, "_blank");
    // };

    // const navigate = useNavigate();

    // const [message, setMessage] = useState("");
    // const [messageType, setMessageType] = useState("");
    const { userId, orderId } = useParams();
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    const [userDetails, setUserDetails] = useState([]);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editedData, setEditedData] = useState([]);

    const emailID = localStorage.getItem("username");

    const fetchUserData = useCallback(() => {
        const url = orderId
            ? `https://api-ft5g.onrender.com/Get-container-place-enquiry-user-and-admin/${userId}/${orderId}`
            : `https://api-ft5g.onrender.com/Get-container-place-enquiry-user-and-admin/${userId}`;

        fetch(url)
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
                return res.json();
            })
            .then((data) => {
                setUserDetails(data.data);
                setEditedData(data.data);
            })
            .catch((err) => console.error("Error fetching data:", err));
    }, [orderId, userId]); // dependencies


    useEffect(() => {
        fetchUserData();
    }, [fetchUserData]); // ✅ No warning now


    const handleSelectAll = (e) => {
        setSelectedOrders(e.target.checked ? userDetails.map((item) => item.CPE_ID) : []);
    };

    const handleCheckboxChange = (cpeId) => {
        setSelectedOrders((prev) =>
            prev.includes(cpeId) ? prev.filter((id) => id !== cpeId) : [...prev, cpeId]
        );
    };

    const handleConvertToOrder = async () => {
        if (selectedOrders.length === 0) {
            setMessage("Please select at least one enquiry to convert.");
            setMessageType("danger");
            return;
        }

        try {
            // Step 1: Convert Enquiries to Orders
            const convertResponse = await fetch("https://api-ft5g.onrender.com/convert-enquiry-to-order", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ cpeIds: selectedOrders }),
            });

            const convertData = await convertResponse.json();

            if (!convertResponse.ok) {
                setMessage(convertData.message || "Failed to convert enquiry to order.");
                setMessageType("danger");
                return;
            }

            // Step 2: Delete Enquiries After Conversion
            const deleteResponse = await fetch("https://api-ft5g.onrender.com/delete-enquiry-after-conversion", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ cpeIds: selectedOrders }),
            });

            const deleteData = await deleteResponse.json();

            if (deleteResponse.ok) {
                setMessage("Enquiries converted and deleted successfully.");
                setMessageType("success");
                setSelectedOrders([]);
                // fetchData(); // Refresh the data if needed

                // ⏳ Automatically hide the message after 3 seconds
                setTimeout(() => {
                    setMessage("");
                    setMessageType("");
                }, 3000);
            } else {
                setMessage(deleteData.message || "Converted but deletion failed.");
                setMessageType("warning");
            }

        } catch (err) {
            setMessage("Network error. Please check your connection.");
            setMessageType("danger");
        }
    };

    const handleEditClick = () => setIsEditing(true);
    const handleSaveClick = () => {
        setIsEditing(false);
        updateData(editedData).then(() => {
            fetchUserData(); // Refresh the data from the backend
            setMessage("Data saved and refreshed successfully.");
            setMessageType("success");

            // Optionally auto-hide message after a few seconds
            setTimeout(() => {
                setMessage("");
                setMessageType("");
            }, 3000);
        });
    };

    // const handleChange = (index, field, value) => {
    //     setEditedData((prev) => prev.map((row, i) => (i === index ? { ...row, [field]: value } : row)));
    // };

    const updateData = async (updatedRows) => {
        try {
            const response = await fetch("https://api-ft5g.onrender.com/update-enquiry", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ data: updatedRows }),
            });
            return response.json(); // return the response to allow chaining
        } catch (error) {
            console.error("Error updating data:", error);
        }
    };



    const handleDownloadExcel = () => {
        if (userDetails.length === 0) {
            setMessage("No data available to download.");
            setMessageType("danger");
            return;
        }

        // Define mapping between keys in userDetails and labels for Excel
        const columnMap = [
            { key: "CPE_ID", label: "CPE ID" },
            { key: "OrderID", label: "Order ID" },
            { key: "UploadDate", label: "Ordered On" },
            { key: "SKU_CODE", label: "SKU Code" },
            { key: "PRODUCT_DESCRIPTION", label: "Product Description" },
            { key: "WEIGHT_PER_PKT_GRAMS", label: "Weight Per Packet (gm)" },
            { key: "UNIT_MEASUREMENT", label: "Unit Measurement" },
            { key: "UNIT_PER_CTN", label: "Quantity" },
            { key: "CartonQty", label: "No. of Cases" },
            { key: "TotalQty", label: "Total QTY" },
            { key: "RatePerUnitUSD", label: "Rate Per Unit USD" },
            { key: "RatePerCaseUSD", label: "Rate Per Case USD" },
            { key: "TotalRateInUSDFobIndia", label: "Total Rate In USD FOB INDIA" },
            { key: "TotalNetWeight", label: "Total Net Weight" },
            { key: "UserStatus", label: "User Status" },
            { key: "UserRemarks", label: "User Remarks" }
        ];

        // Format data to match key order
        const formattedData = userDetails.map(item => {
            const reordered = {};
            columnMap.forEach(({ key, label }) => {
                reordered[label] = item[key] ?? "";
            });
            return reordered;
        });

        // Extract just the column labels for headers
        const headers = columnMap.map(col => col.label);

        // Create Excel worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData, { header: headers });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "EnquiryDetails");

        XLSX.writeFile(workbook, `Enquiry_Details_${new Date().toISOString()}.xlsx`);
    };


    const handleChange = (index, field, value) => {
        setEditedData((prev) => {
            const updated = [...prev];
            const row = { ...updated[index], [field]: parseFloat(value) || 0 };

            // Perform auto calculations only when RatePerUnitUSD is updated
            if (field === "RatePerUnitUSD") {
                // const unitsPerCtn = parseFloat(row.UNIT_PER_CTN) || 0;
                const cartonQty = parseFloat(row.CartonQty) || 0;
                const weightPerPkt = parseFloat(row.WEIGHT_PER_PKT_GRAMS) || 0;
                const totalqty = parseFloat(row.TotalQty) || 0

                row.RatePerCaseUSD = parseFloat((row.RatePerUnitUSD * cartonQty).toFixed(2));
                row.TotalRateInUSDFobIndia = parseFloat((row.RatePerUnitUSD * totalqty).toFixed(2));
                row.TotalNetWeight = parseFloat(((totalqty * weightPerPkt) / 1000).toFixed(2));
            }

            updated[index] = row;
            return updated;
        });
    };


    const sendEnquiryEmail = async () => {
        try {
            const response = await fetch('https://api-ft5g.onrender.com/send-enquiry-update-email', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: emailID }),
            });

            const result = await response.json();

            if (response.ok) {
                alert('Email sent successfully!');
            } else {
                alert('Failed to send email: ' + result.message);
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Something went wrong. Please try again later.');
        }
    };


    const totals = editedData.reduce(
        (acc, item) => {
            acc.cases += parseFloat(item.CartonQty) || 0;
            acc.totalQty += parseFloat(item.TotalQty) || 0;
            acc.totalRate += parseFloat(item.TotalRateInUSDFobIndia) || 0;
            acc.totalWeight += parseFloat(item.TotalNetWeight) || 0;
            return acc;
        },
        { cases: 0, totalQty: 0, totalRate: 0, totalWeight: 0 }
    );



    // const [conversionRate, setConversionRate] = useState(null);

    // // Fetch real-time INR to USD conversion rate
    // useEffect(() => {
    //     fetch("https://api.exchangerate.host/latest?base=INR&symbols=USD")
    //         .then(res => res.json())
    //         .then(data => {
    //             if (data && data.rates && data.rates.USD) {
    //                 setConversionRate(data.rates.USD);
    //             } else {
    //                 setConversionRate(1 / 83.5); // Fallback if API fails
    //             }
    //         })
    //         .catch(err => {
    //             console.error("Error fetching conversion rate:", err);
    //             setConversionRate(1 / 83.5); // Fallback if network fails
    //         });
    // }, []);

    // const [debounceTimers, setDebounceTimers] = useState({});
    // const [convertingStatus, setConvertingStatus] = useState({});

    // const handleChange = (index, field, value) => {
    //     const updatedData = [...editedData];
    //     updatedData[index] = {
    //         ...updatedData[index],
    //         [field]: value,
    //     };
    //     setEditedData(updatedData);

    //     // Clear previous timer
    //     if (debounceTimers[`${index}-${field}`]) {
    //         clearTimeout(debounceTimers[`${index}-${field}`]);
    //     }

    //     if ((field === "RatePerUnitUSD" || field === "RatePerCaseUSD") && conversionRate) {

    //         // Show "Converting..." indicator
    //         setConvertingStatus((prev) => ({
    //             ...prev,
    //             [`${index}-${field}`]: true,
    //         }));

    //         const newTimers = { ...debounceTimers };
    //         newTimers[`${index}-${field}`] = setTimeout(() => {
    //             const inrValue = parseFloat(value);
    //             if (!isNaN(inrValue)) {
    //                 const usdValue = inrValue * conversionRate;

    //                 const updated = [...editedData];
    //                 updated[index][field] = usdValue.toFixed(2);
    //                 setEditedData(updated);
    //             }

    //             // Hide "Converting..." indicator
    //             setConvertingStatus((prev) => ({
    //                 ...prev,
    //                 [`${index}-${field}`]: false,
    //             }));
    //         }, 3000);

    //         setDebounceTimers(newTimers);
    //     }
    // };

    const handleLogout = () => {
        localStorage.clear();
        // Delay navigation slightly to ensure clear completes
        setTimeout(() => {
            navigate("/AdminLogin");
        }, 100); // 100ms is usually enough
    };


    const [unauthorized, setUnauthorized] = useState(false);

    useEffect(() => {
        if (!hasAccess("Enquiry Update Page")) {
            setUnauthorized(true);

            // After 5 seconds, logout and redirect
            const timer = setTimeout(() => {
                localStorage.clear();
                navigate("/AdminLogin");
            }, 3000);

            return () => clearTimeout(timer); // cleanup
        }
    }, [navigate]);

    // ✅ Show unauthorized message if no access
    if (unauthorized) {
        return (
            <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
                <h2>🚫 Access Denied</h2>
                <p>You are not authorized to view this page.<br />You will be logged out in 3 seconds...</p>
            </div>
        );
    }

    return (
        <>
            <Navbar collapseOnSelect expand="lg" className="navibar" sticky="top">
                <Container>
                    {/* <Button onClick={scrollToTop} className="logoscrollbtn p-0"> */}
                    <Navbar.Brand href="/">
                        <img src={Logo}
                            alt="logo"
                            className="d-inline-block align-top logo" />
                    </Navbar.Brand>
                    {/* </Button> */}

                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        {/* <Nav className="me-auto">
                                </Nav> */}

                        <Nav>
                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Dashboard Page") && <Nav.Link as={Link} to="/AdminDash" className="adminnavtext">Dashboard</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Customers Page") && <Nav.Link as={Link} to="/Customers" className="adminnavtext">Customers</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Category Page") && <Nav.Link as={Link} to="/Category" className="adminnavtext">Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Sub - Category Page") && <Nav.Link as={Link} to="/SubCategory" className="adminnavtext">Sub-Category</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Brands Page") && <Nav.Link as={Link} to="/Brands" className="adminnavtext">Brands</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Products Page") && <Nav.Link as={Link} to="/AdminProducts" className="adminnavtext">Products</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Enquiry Page") && <Nav.Link as={Link} to="/Quotations" className="adminnavtext">Enquiries</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Order Page") && <Nav.Link as={Link} to="/AdminOrder" className="adminnavtext">Orders</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Contact Page") && <Nav.Link as={Link} to="/ContactUsResponse" className="adminnavtext">Contact</Nav.Link>}
                            </Button>

                            <Button onClick={scrollToTop} className="scrollbtn p-0 mx-2">
                                {hasAccess("Offline Order Page") && <Nav.Link as={Link} to="/OfflineOrder" className="adminnavtext">Offline Order</Nav.Link>}
                            </Button>

                            <Dropdown>
                                <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 responsiveview" id="dropdown-basic">
                                    <img src={Account}
                                        alt="account"
                                        className="d-inline-block align-top"
                                    />
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                                    {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                                    {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                                    <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>

                    <Dropdown>
                        <Dropdown.Toggle className="scrollbtn3 p-0 mx-2 mt-1 mobileview" id="dropdown-basic">
                            <img src={Account}
                                alt="account"
                                className="d-inline-block align-top"
                            />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {/* <Dropdown.Item href="/Profile">My Profile</Dropdown.Item> */}
                            {/* <Dropdown.Item href="/OrderPage">Past Orders</Dropdown.Item> */}
                            {hasAccess("Admin Permission Page") && <Dropdown.Item href="/AdminPermission">Admin Permission</Dropdown.Item>}
                            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                    <Nav></Nav>
                </Container>
            </Navbar>

            {/* ----------------Navbar Complete---------------- */}

            {message && (
                <div className={`alert alert-${messageType}`} role="alert">
                    {message}
                </div>
            )}


            <Container fluid className="">
                <Row>
                    <Col lg={3} className="mt-3">
                        <Button onClick={isEditing ? handleSaveClick : handleEditClick} className="w-100">
                            {isEditing ? "Save" : "Edit"}
                        </Button>
                    </Col>

                    <Col lg={3} className="mt-3">
                        <Button className="w-100 convertbtn" onClick={handleConvertToOrder} disabled={selectedOrders.length === 0}>
                            Convert Enquiry to Order
                        </Button>
                    </Col>

                    <Col lg={3} className="mt-3">
                        <Button className="w-100" onClick={handleDownloadExcel}>
                            Download as Excel
                        </Button>
                    </Col>

                    <Col lg={3} className="mt-3">
                        <Button onClick={sendEnquiryEmail} className="w-100 btn-success">
                            Send Enquiry Email
                        </Button>
                    </Col>
                </Row>

                <Row>
                    {/* <Col lg={8} className="mt-3">
                        <Card className="p-4">
                            <h5 className="text-center mb-4">ENQUIRY DETAILS</h5>

                            {
                                orderDetails.length > 0 ? (
                                    orderDetails.map((item, index) => (
                                        <Row key={index}>
                                            <hr className="mt-3 mb-3" />
                                            <Col>
                                                <Row className="text-center mb-2 mt-3">
                                                    <Col>
                                                        <p className="mb-1 text-muted orderfont2">{item.OrderID}</p>
                                                        <h4 className="orderfont1">{item.PRODUCT_DESCRIPTION}</h4>
                                                    </Col>
                                                    <Col>
                                                        <p className="text-muted mb-1 orderfont1">ORDERED ON</p>
                                                        <p className="orderfont1">{item.UploadDate}</p>
                                                    </Col>
                                                    <Col>
                                                        <p className="text-muted mb-1 orderfont1">SKU CODE</p>
                                                        <p className="text-muted orderfont1">{item.SKU_CODE}</p>
                                                    </Col>
                                                </Row>

                                                <Row className="text-center">
                                                    <Col className="mt-4">
                                                        <p className="text-muted mb-1 orderfont1">QUANTITY</p>
                                                        <p className="orderfont1">{item.UNIT_PER_CTN} {item.UNIT} / CARTONS</p>
                                                    </Col>
                                                    <Col className="mt-4">
                                                        <p className="text-muted mb-1 orderfont1">NO. OF CARTONS</p>
                                                        <p className="orderfont1">{item.CartonQty}</p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    ))
                                ) : (
                                    <p>No details available for this order.</p>
                                )
                            }

                            <hr className="my-4" />

                            <p className="text-center text-muted orderfont">
                                Your order will be delivered tentetively by <span style={{ fontWeight: "bold" }}>15 Dec 2024</span>
                            </p>

                            <hr />
                        </Card>
                    </Col> */}

                    <Col className="mt-3">
                        <Card className="p-4">
                            <h5 className="text-center mb-4">ENQUIRY DETAILS</h5>
                            {userDetails.length > 0 ? (
                                <>
                                    <div className="d-flex align-items-center mb-3">
                                        <input type="checkbox" onChange={handleSelectAll} checked={selectedOrders.length === userDetails.length} />
                                        <label className="mx-3">Select All</label>
                                    </div>
                                    <Table responsive bordered hover>
                                        <thead>
                                            <tr className="text-center">
                                                <th>Select</th>
                                                <th>CPE ID</th>
                                                <th>Order ID</th>
                                                <th>Ordered On</th>
                                                <th>SKU Code</th>
                                                <th>Brand</th>
                                                <th>Product Description</th>
                                                <th>Weight Per Packet (gm)</th>
                                                <th>Unit Size</th>
                                                <th>Unit Measurement Type</th>
                                                <th>Unit Per Case</th>
                                                <th>No. of Cases</th>
                                                <th>Total Qty</th>
                                                <th>Rate Per Unit (USD)</th>
                                                <th>Rate Per Case (USD)</th>
                                                <th>Total Rate FOB INDIA (USD)</th>
                                                <th>Total Weight</th>
                                                <th>User Status</th>
                                                <th>User Remarks</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userDetails.map((item, index) => (
                                                <tr key={item.CPE_ID} className="text-center">
                                                    <td>
                                                        <input type="checkbox" checked={selectedOrders.includes(item.CPE_ID)} onChange={() => handleCheckboxChange(item.CPE_ID)} />
                                                    </td>
                                                    <td>{item.CPE_ID}</td>
                                                    <td>{item.OrderID}</td>
                                                    <td>{new Date(item.UploadDate).toLocaleDateString()}</td>
                                                    <td>{item.SKU_CODE}</td>
                                                    <td>{item.BRAND}</td>
                                                    <td>{item.PRODUCT_DESCRIPTION}</td>
                                                    <td>{item.WEIGHT_PER_PKT_GRAMS}</td>
                                                    <td>{item.UNIT_MEASUREMENT}</td>
                                                    <td>{item.UNIT_MEASUREMENT_TYPE}</td>
                                                    <td>{item.UNIT_PER_CTN} {item.UNIT}</td>
                                                    <td>{item.CartonQty}</td>
                                                    <td>{item.TotalQty}</td>
                                                    {/* {['RatePerUnitUSD', 'RatePerCaseUSD', 'TotalRateInUSDFobIndia', 'TotalNetWeight'].map((field) => (
                                                        <td key={field}>
                                                            {isEditing ? (
                                                                <input
                                                                    type="number"
                                                                    value={editedData[index]?.[field] !== undefined ? editedData[index][field] : ""}
                                                                    onChange={(e) => handleChange(index, field, e.target.value)}
                                                                />
                                                            ) : (
                                                                userDetails[index]?.[field] !== undefined && userDetails[index][field] !== null
                                                                    ? userDetails[index][field]  // Show stored data from the database
                                                                    : "-" // Fallback if no data exists
                                                            )}
                                                        </td>
                                                    ))} */}

                                                    {isEditing ? (
                                                        <td>
                                                            <input
                                                                type="number"
                                                                value={editedData[index]?.RatePerUnitUSD ?? ""}
                                                                onChange={(e) => handleChange(index, "RatePerUnitUSD", e.target.value)}
                                                            />
                                                        </td>
                                                    ) : (
                                                        <td>{Number(item.RatePerUnitUSD ?? "-").toFixed(2)}</td>
                                                    )}
                                                    <td>{!isNaN(parseFloat(editedData[index]?.RatePerCaseUSD)) ? parseFloat(editedData[index].RatePerCaseUSD).toFixed(2) : "-"}</td>
                                                    <td>{!isNaN(parseFloat(editedData[index]?.TotalRateInUSDFobIndia)) ? parseFloat(editedData[index].TotalRateInUSDFobIndia).toFixed(2) : "-"}</td>
                                                    <td>{!isNaN(parseFloat(editedData[index]?.TotalNetWeight)) ? parseFloat(editedData[index].TotalNetWeight).toFixed(2) : "-"}</td>
                                                    <td>{item.UserStatus}</td>
                                                    <td>{item.UserRemarks}</td>
                                                </tr>
                                            ))}

                                            <tr className="text-center">
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>TOTAL</td>
                                                <td>{totals.cases}</td>
                                                <td>{totals.totalQty}</td>
                                                <td></td>
                                                <td></td>
                                                <td>{totals.totalRate.toFixed(2)}</td>
                                                <td>{totals.totalWeight.toFixed(2)}</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </>
                            ) : (
                                <p className="text-center text-muted">No details available for this order.</p>
                            )}

                            {/* <hr className="my-4" />
                            <p className="text-center text-muted orderfont">
                                Your order will be delivered tentatively by <span style={{ fontWeight: "bold" }}>15 Dec 2024</span>
                            </p> */}
                        </Card>
                    </Col>

                    {/* <Col className="mt-3 mb-3" lg={4}>
                        <Card>
                            <Form onSubmit={handleSubmit}> */}
                    {/* Display Success/Error Message */}
                    {/* {message && (
                                    <Alert
                                        variant={messageType}
                                        className="mx-3 mt-3"
                                        onClose={() => setMessage("")}
                                        dismissible
                                    >
                                        {message}
                                    </Alert>
                                )} */}
                    {/* File Upload Fields */}
                    {/* <Row>
                                    <Col className="mt-3 mx-3">
                                        <Form.Group controlId="formFileQuotation" className="mb-3">
                                            <Form.Label>Upload Quotation</Form.Label>
                                            <Form.Control
                                                type="file"
                                                name="quotationFile"
                                                onChange={(e) => handleFileChange(e, setQuotationFile)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row> */}

                    {/* Submit Button */}
                    {/* <Row>
                                    <Col className="mt-3 mb-3 mx-3">
                                        <Button type="submit" className="adminproductsaddnewcatebtn w-100">
                                            Submit
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card> */}



                    {/* {message && (
                            <Row className="mt-3">
                                <Col>
                                    <div className={`alert alert-${messageType} text-center`}>{message}</div>
                                </Col>
                            </Row>
                        )}
                        <Row>
                            <Col className="mb-3 mt-3">
                                <Card className="p-3">
                                    <h4 className="mb-3">Uploaded Files</h4>
                                    {error && <p className="text-danger">{error}</p>}
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>File Name</th>
                                                <th>File Type</th>
                                                <th>Uploaded Date</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {files.map((file, index) => (
                                                <tr key={index}>
                                                    <td>{file.FileName}</td>
                                                    <td>{file.FileType}</td>
                                                    <td>{new Date(file.UploadDate).toLocaleString()}</td>
                                                    <td>
                                                        <Button
                                                            variant="primary"
                                                            onClick={() => handleDownload(file.FileName)}
                                                        >
                                                            Download
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Card>
                            </Col>
                        </Row> 
                    </Col>*/}
                </Row>
            </Container >
        </>
    );
}

export default ViewQuotationEnquiry;